module.exports = __webpack_public_path__ + "static/6-541a80509b808eba28af7f70ef496191.png";